import React, { useEffect, useState } from 'react'
import "./series.css"
import axios from "axios"
import useGenres from "../../hooks/useGenres"
import CustomPagination from "../../components/Pagination/CustomPagination"
import SingleContent from '../../components/SingleContent/SingleContent'
import Genres from '../../components/Genres'


const Series = () => {
  const [content, setContent] = useState([])
  const [page, setPage] = useState(1)
  const [numOfPages, setNumOfPages] = useState(10)
  const [selectedGenres, setSelectedGenres] = useState([])
  const [genres, setGenres] = useState([])
  const genresForUrl = useGenres(selectedGenres)

  useEffect(() => {
    axios.get(`https://api.themoviedb.org/3/discover/tv?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}&with_genres=${genresForUrl}`)
      .then(res => {
        // console.log(res.data)
        setContent(res.data.results)
        setNumOfPages(res.data.total_pages)
      })
      .catch(err => {
        console.log("error --> ", err)
      })
  }, [page, selectedGenres])

  return (
    <div className='page'>
      <h2 className='page-title'>TV Series</h2>
      <Genres type="movie" setPage={setPage}
        genres={genres} setGenres={setGenres} 
        selectedGenres={selectedGenres} setSelectedGenres={setSelectedGenres} 
      />
      <div className="movies">
        {content && content.map((movie, i) => {
          return <SingleContent key={i} movie={movie} mediaType={"tv"} />
        })}
      </div>
      <CustomPagination setPage={setPage} numOfPages={numOfPages} />
    </div>
  )
}

export default Series
